import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from './navigation.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private navigationService: NavigationService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.navigationService.menuLoaded) {
      const item = this.navigationService.menu$.value.find(menu => menu.name === route.routeConfig.path);
      const hasPermission = item ? true : false;
      if (!hasPermission) {
        setTimeout(() => {
          window.history.go(-1);
        }, 0);
      }
      return hasPermission;
    } else {
      return true;
    }
  }
}
